export default "__VITE_ASSET__dd582917__"